import axios from "axios";
import {
  UPLOAD_STRUCTURE01_REQUEST,
  UPLOAD_STRUCTURE01_SUCCESS,
  UPLOAD_STRUCTURE01_FAILURE,
  UPLOAD_STRUCTURE02_REQUEST,
  UPLOAD_STRUCTURE02_SUCCESS,
  UPLOAD_STRUCTURE02_FAILURE,
  UPLOAD_STRUCTURE03_REQUEST,
  UPLOAD_STRUCTURE03_SUCCESS,
  UPLOAD_STRUCTURE03_FAILURE,
  UPLOAD_STRUCTURE04_REQUEST,
  UPLOAD_STRUCTURE04_SUCCESS,
  UPLOAD_STRUCTURE04_FAILURE,
  UPLOAD_STRUCTURE05_REQUEST,
  UPLOAD_STRUCTURE05_SUCCESS,
  UPLOAD_STRUCTURE05_FAILURE,

  UPLOAD_STRUCTURE09_REQUEST,
  UPLOAD_STRUCTURE09_SUCCESS,
  UPLOAD_STRUCTURE09_FAILURE,
  

  SAVE_OCR_PAYLOAD_REQUEST,
  SAVE_OCR_PAYLOAD_SUCCESS,
  SAVE_OCR_PAYLOAD_FAILURE,
} from "./ocrTypes";

import Config from "../../config/index";
// let baseUrl = Config.baseUrl; 
let baseUrlReport = Config.baseUrlReport;

//    STRUCTURE 01
const uploadStructure01Request = () => ({ type: UPLOAD_STRUCTURE01_REQUEST });
const uploadStructure01Success = (payload) => ({
  type: UPLOAD_STRUCTURE01_SUCCESS,
  payload,
});
const uploadStructure01Failure = (error) => ({
  type: UPLOAD_STRUCTURE01_FAILURE,
  payload: error,
});

const uploadStructure01 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload6`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure01Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure01Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure01Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

//  STRUCTURE 02
const uploadStructure02Request = () => ({ type: UPLOAD_STRUCTURE02_REQUEST });
const uploadStructure02Success = (payload) => ({
  type: UPLOAD_STRUCTURE02_SUCCESS,
  payload,
});
const uploadStructure02Failure = (error) => ({
  type: UPLOAD_STRUCTURE02_FAILURE,
  payload: error,
});

const uploadStructure02 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload5?`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure02Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure02Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure02Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

//  STRUCTURE 03
const uploadStructure03Request = () => ({ type: UPLOAD_STRUCTURE03_REQUEST });
const uploadStructure03Success = (payload) => ({
  type: UPLOAD_STRUCTURE03_SUCCESS,
  payload,
});
const uploadStructure03Failure = (error) => ({
  type: UPLOAD_STRUCTURE03_FAILURE,
  payload: error,
});

const uploadStructure03 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload4`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure03Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure03Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure03Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

//  STRUCTURE 04
const uploadStructure04Request = () => ({ type: UPLOAD_STRUCTURE04_REQUEST });
const uploadStructure04Success = (payload) => ({
  type: UPLOAD_STRUCTURE04_SUCCESS,
  payload,
});
const uploadStructure04Failure = (error) => ({
  type: UPLOAD_STRUCTURE04_FAILURE,
  payload: error,
});

const uploadStructure04 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload11`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure04Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure04Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure04Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};

//  STRUCTURE 05
const uploadStructure05Request = () => ({ type: UPLOAD_STRUCTURE05_REQUEST });
const uploadStructure05Success = (payload) => ({
  type: UPLOAD_STRUCTURE05_SUCCESS,
  payload,
});
const uploadStructure05Failure = (error) => ({
  type: UPLOAD_STRUCTURE05_FAILURE,
  payload: error,
});

const uploadStructure05 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload8`;
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure05Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure05Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure05Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadStructure09Request = () => ({ type: UPLOAD_STRUCTURE09_REQUEST });

const uploadStructure09Success = (payload) => ({
  type: UPLOAD_STRUCTURE09_SUCCESS,
  payload,
});

const uploadStructure09Failure = (error) => ({
  type: UPLOAD_STRUCTURE09_FAILURE,
  payload: error,
});

 const uploadStructure09 = (formData, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/upload9`; 
  
  const headers = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(uploadStructure09Request());
    return axios
      .post(url, formData, headers)
      .then((res) => {
        dispatch(uploadStructure09Success(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(uploadStructure09Failure(err.response));
        return { status: false, data: err.response };
      });
  };
};


//  SAVE EXTRACTED DATA
const saveExtractedDataRequest = () => ({ type: SAVE_OCR_PAYLOAD_REQUEST });
const saveExtractedDataSuccess = (payload) => ({
  type: SAVE_OCR_PAYLOAD_SUCCESS,
  payload,
});
const saveExtractedDataFailure = (error) => ({
  type: SAVE_OCR_PAYLOAD_FAILURE,
  payload: error,
});

const saveExtractedData = (finalPayload, jwtToken) => {
  const url = `${baseUrlReport}/ocr_with_google_api/save`;
  const headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(saveExtractedDataRequest());
    return axios
      .post(url, finalPayload, headers)
      .then((res) => {
        dispatch(saveExtractedDataSuccess(res.data));
        return { status: true, data: res.data };
      })
      .catch((err) => {
        dispatch(saveExtractedDataFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  uploadStructure01,
  uploadStructure02,
  uploadStructure03,
  uploadStructure04,
  uploadStructure05,
  uploadStructure09,
  saveExtractedData,
};
